import { isImpersonating } from './utils/impersonation';

const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://onepurposelogistics-api.onrender.com/api'
  : 'http://localhost:5000/api';

let refreshPromise = null;

export async function getFreshSupabaseToken() {
  // While a super admin is viewing as someone, this token IS the target's session and must be
  // handed over as-is. Refreshing it would use the ADMIN's stored refresh token and silently swap
  // the impersonated identity back to the admin — which would break RLS scoping mid-session.
  if (isImpersonating()) return localStorage.getItem('supabase_token');

  const token = localStorage.getItem('supabase_token');
  const refreshToken = localStorage.getItem('supabase_refresh_token');
  if (!token || !refreshToken) return token;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp * 1000 - Date.now() > 5 * 60 * 1000) return token;
  } catch {
    return token;
  }

  if (!refreshPromise) {
    refreshPromise = (async () => {
      try {
        const res = await fetch(`${API_URL}/auth/refresh-token`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh_token: refreshToken })
        });
        const data = await res.json();
        if (res.ok && data.success && data.supabase_token) {
          localStorage.setItem('supabase_token', data.supabase_token);
          if (data.supabase_refresh_token) {
            localStorage.setItem('supabase_refresh_token', data.supabase_refresh_token);
          }
          return data.supabase_token;
        }
        localStorage.removeItem('token');
        localStorage.removeItem('supabase_token');
        localStorage.removeItem('supabase_refresh_token');
        localStorage.removeItem('user');
        localStorage.removeItem('subbieId');
        window.location.href = '/login';
        return null;
      } finally {
        refreshPromise = null;
      }
    })();
  }
  return refreshPromise;
}